// @mui
import { RadioGroup, Typography } from '@mui/material';
//
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { useThemeSettingsContext } from '../ThemeSettingsContext';
import { MaskControl, StyledCard, StyledWrap } from '../styles';

const OPTIONS = ['light', 'dark'] as const;

type Props = {
  onlyIcon?: boolean;
  size?: 'small' | 'big';
};

export default function ModeOptions({ onlyIcon = false, size = 'big' }: Props) {
  const { translate } = useLocales();
  const { themeMode, onChangeMode } = useThemeSettingsContext();

  return (
    <RadioGroup name="themeMode" value={themeMode} onChange={onChangeMode}>
      <StyledWrap>
        {OPTIONS.map((mode) => (
          <StyledCard key={mode} selected={themeMode === mode} size={size}>
            <Iconify icon={mode === 'light' ? 'tabler:sun' : 'tabler:moon'} />
            {!onlyIcon && (
              <Typography variant="subtitle2" textTransform="capitalize">
                {mode === 'light'
                  ? translate('shared.styles.light')
                  : translate('shared.styles.dark')}
              </Typography>
            )}
            <MaskControl value={mode} />
          </StyledCard>
        ))}
      </StyledWrap>
    </RadioGroup>
  );
}
